import { CommonLayout } from '../commonComponents';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
  Router,
  useParams,
} from 'react-router';
import AdditionalKYCDetails from './additionalKYCDetails';
import BankDetails from './bankDetails';
import {
  InvestorDetailsLayout,
  investorEditDocumentDetailsObj,
  investorEditEndpointExcludingDoc,
  investorEditEndpointIncludingDoc,
} from './components';
import ContactDetails from './contactDetails';
import ContributorDetails from './contributorDetails';
import DistributorDetails from './distributorDetails';
import DocumentDetails from './documentDetails';
import Fatca from './fatca';
import InvestmentPaymentDetails from './investmentPaymentDetails';
import NomineeDetails from './nomineeDetails';
import {
  FormValidationForDisplayCompleteApplicationButtonForInvestor,
  getApplicationDetails,
  getCompanies,
  getDocuments,
  getInvestorEditSections,
} from '../../redux-store/actions/application';
import {
  ApplicationProps,
  RiskProfileMaster,
  currentDateType,
  getDetailsByRefrenceType,
} from '../../redux-store/types/api-types';
import { Location } from 'history';
import { RootStateType } from '../../redux-store/reducers';
import { APMIFlow, USER_ROLES } from '../../utils/constant';
// import StrategyDetails from './strategyDetails';
import SourceOfInvestment from './sourceOfInvestment';
import riskProfile from './riskProfileDetails';
import RelatedPartyConsent from './relatedPartyDetails';
import DisclosureOfInterest from './disclosureOfInterestDetails';
import DisclosureOfExcluded from './disclosureOfExclusions';
import StrategyDetails from './strategyDetailsWithFeeSlabs';
import {
  getApplicationDetailsWithRefId,
  getDetailByReferenceId,
} from '../../redux-store/actions/onBoarding';
import { getCurrentDate, riskProfileMasterData } from '../../redux-store/actions';
import { InvestorEditErrorObj } from '../../redux-store/reducers/investorEditSections';
import { companyType } from '../../redux-store/types/mdms';
import KycAddressDetails from './kycAddressDetails';
import KycPersonalDetails from './kycPersonalDetails';

export const Routes = ({
  id,
  applicant1ReferenceId,
}: {
  id: string;
  applicant1ReferenceId?: string;
  applicationType?: string;
}): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { path } = useRouteMatch();

  const {
    auth: { role },
    application: { application: _application },
    investor: { token: investorToken = '' },
  } = useSelector((store: RootStateType) => store);

  const { applicationNumber } = _application || {};
  const kycUpdateRouteCheck = path === '/investment-details/:referenceId/kyc-update';
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const { investorEditObj } = useSelector((store: RootStateType) => store.investorEditObj);
  const [documentsResponse, setDocumentResponse] = useState<Document>();
  const [riskProfileMasterResponse, setRiskProfileMasterResponse] = useState<RiskProfileMaster>();
  const [companyList, setCompanyList] = useState<companyType>({ companies: [] });
  const [currentDate, setCurrentDate] = useState<string | Date>('');
  const { referenceId } = useParams<{ referenceId: string }>();

  useEffect(() => {
    async function fetchApplication() {
      try {
        if (kycUpdateRouteCheck) {
          referenceId &&
            ((await dispatch(
              getDetailByReferenceId(referenceId)
            )) as unknown as getDetailsByRefrenceType);
          referenceId &&
            ((await dispatch(
              getApplicationDetailsWithRefId(referenceId)
            )) as unknown as ApplicationProps);
          return;
        }

        if ((role === USER_ROLES.INVESTOR || referenceId) && !investorToken) {
          history.push(`/investment-details/${applicant1ReferenceId}/details`);
          return;
        }

        // if (investorToken && id) {
        //   const { date: currentDateDate } = (await dispatch(
        //     getCurrentDate()
        //   )) as unknown as currentDateType;
        //   setCurrentDate(currentDateDate);
        //   (await dispatch(
        //     getDetailByReferenceId(applicant1ReferenceId || '')
        //   )) as unknown as getDetailsByRefrenceType;
        //   (await dispatch(getApplicationDetails(id))) as unknown as ApplicationProps;
        //   const responseRisk = (await dispatch(
        //     riskProfileMasterData()
        //   )) as unknown as RiskProfileMaster;
        //   setRiskProfileMasterResponse(responseRisk);
        //   const companies = (await dispatch(getCompanies())) as unknown as companyType;
        //   setCompanyList(companies);
        //   const docResponse = (await dispatch(getDocuments())) as unknown as Document;
        //   setDocumentResponse(docResponse);
        //   return;
        // }

        if (
          referenceDetail.applicant_type &&
          (APMIFlow && referenceDetail.applicant_type === '1'
            ? investorEditObj?.find(
                (menu) => menu.endPoint === investorEditDocumentDetailsObj.endPoint
              )
              ? !investorEditEndpointIncludingDoc.includes(
                  history?.location?.pathname?.split('/')?.pop() || ''
                )
              : !investorEditEndpointExcludingDoc.includes(
                  history?.location?.pathname?.split('/')?.pop() || ''
                )
            : !investorEditObj || (investorEditObj && investorEditObj.length === 0))
        ) {
          history.push(`/investment-details/${applicant1ReferenceId}/application-details`);
          return;
        }
        if (id) {
          (await dispatch(getApplicationDetails(id))) as unknown as ApplicationProps;
        } else {
          history.push('/');
          console.error('No application id found');
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    }
    // if (application === null) {
    fetchApplication();
    // }
  }, []);

  useEffect(() => {
    (async function () {
      if (investorToken && _application && riskProfileMasterResponse && documentsResponse) {
        try {
          await FormValidationForDisplayCompleteApplicationButtonForInvestor(
            _application,
            documentsResponse,
            role,
            riskProfileMasterResponse.riskProfile,
            referenceDetail,
            true,
            true,
            true,
            true,
            companyList.companies,
            currentDate
          );
        } catch (error) {
          await dispatch(getInvestorEditSections(error as unknown as InvestorEditErrorObj[]));
        }
      }
    })();
  }, [documentsResponse]);

  return (
    <InvestorDetailsLayout
      applicationId={id}
      applicant1ReferenceId={applicant1ReferenceId}
      applicationNumber={applicationNumber || ''}>
      <Router history={history}>
        <Switch>
          <Route
            exact
            path={path}
            render={() => (
              <Redirect
                to={{
                  pathname: `${path}/distributor-details`,
                  state: { id, applicant1ReferenceId },
                }}
                from={location.pathname}
              />
            )}
          />
          <Route path={`${path}/distributor-details`} component={DistributorDetails} />
          <Route path={`${path}/contributor-details`} component={ContributorDetails} />
          <Route path={`${path}/contact-details`} component={ContactDetails} />
          <Route path={`${path}/additional-KYC-details`} component={AdditionalKYCDetails} />
          <Route path={`${path}/fatca`} component={Fatca} />
          <Route path={`${path}/nominee-details`} component={NomineeDetails} />
          <Route path={`${path}/bank-details`} component={BankDetails} />
          <Route path={`${path}/risk-profiles`} component={riskProfile} />
          <Route path={`${path}/strategy-details`} component={StrategyDetails} />
          <Route path={`${path}/investment-payment-details`} component={InvestmentPaymentDetails} />
          <Route path={`${path}/related-party-consent`} component={RelatedPartyConsent} />
          <Route path={`${path}/disclosure-of-interest`} component={DisclosureOfInterest} />
          <Route path={`${path}/disclosure-of-exclusions`} component={DisclosureOfExcluded} />
          <Route path={`${path}/document-details`} component={DocumentDetails} />
          <Route path={`${path}/personal-contact-details`} component={KycPersonalDetails} />
          <Route path={`${path}/address-details`} component={KycAddressDetails} />
          <Route path={`${path}/xmlDocument-details`} component={DocumentDetails} />
          {/* <Route path={`${path}/source-of-investment`} component={SourceOfInvestment} /> */}
        </Switch>
      </Router>
    </InvestorDetailsLayout>
  );
};

export const InvestorPhotoCaptureEditRoutes = ({
  id,
  applicant1ReferenceId,
}: {
  id: string;
  applicant1ReferenceId?: string;
}): JSX.Element => {
  const history = useHistory();
  const { path } = useRouteMatch();

  const {
    application: { application: _application },
  } = useSelector((store: RootStateType) => store);

  const { applicationNumber } = _application || {};

  return (
    <InvestorDetailsLayout
      applicationId={id}
      applicant1ReferenceId={applicant1ReferenceId}
      applicationNumber={applicationNumber || ''}
      investorLoginType={'investor_photoCapture'}>
      <Router history={history}>
        <Switch>
          <Route
            exact
            path={path}
            render={() => (
              <Redirect
                to={{
                  pathname: `${path}/distributor-details`,
                  state: { id, applicant1ReferenceId },
                }}
                from={location.pathname}
              />
            )}
          />
          <Route path={`${path}/distributor-details`} component={DistributorDetails} />
          <Route path={`${path}/contributor-details`} component={ContributorDetails} />
          <Route path={`${path}/contact-details`} component={ContactDetails} />
          <Route path={`${path}/additional-KYC-details`} component={AdditionalKYCDetails} />
          <Route path={`${path}/fatca`} component={Fatca} />
          <Route path={`${path}/nominee-details`} component={NomineeDetails} />
          <Route path={`${path}/bank-details`} component={BankDetails} />
          <Route path={`${path}/risk-profiles`} component={riskProfile} />
          <Route path={`${path}/strategy-details`} component={StrategyDetails} />
          <Route path={`${path}/investment-payment-details`} component={InvestmentPaymentDetails} />
          <Route path={`${path}/related-party-consent`} component={RelatedPartyConsent} />
          <Route path={`${path}/disclosure-of-interest`} component={DisclosureOfInterest} />
          <Route path={`${path}/disclosure-of-exclusions`} component={DisclosureOfExcluded} />
          <Route path={`${path}/document-details`} component={DocumentDetails} />
          {/* <Route path={`${path}/source-of-investment`} component={SourceOfInvestment} /> */}
        </Switch>
      </Router>
    </InvestorDetailsLayout>
  );
};

const ApplicationRoutes = ({
  location,
}: {
  location: Location<{ id: string; applicant1ReferenceId?: string; applicationType?: string }>;
}): JSX.Element => {
  const { id = '', applicant1ReferenceId = '', applicationType = '' } = location.state || {};
  return (
    <CommonLayout>
      <Routes
        id={id}
        applicant1ReferenceId={applicant1ReferenceId}
        applicationType={applicationType}
      />
    </CommonLayout>
  );
};

export default ApplicationRoutes;
